import { useEffect } from 'react';

const useMeta = ({ title, metas = [] }) => {
  useEffect(() => {
    // Backup title cũ
    const previousTitle = document.title;

    if (title) {
      document.title = title;
    }

    // Backup & cập nhật các thẻ meta
    const previousMetas = [];

    metas.forEach(({ name, property, content }) => {
      if (!content) return;

      const selector = name
        ? `meta[name="${name}"]`
        : property
        ? `meta[property="${property}"]`
        : null;

      if (!selector) return;

      const existingMeta = document.head.querySelector(selector);

      if (existingMeta) {
        // Lưu giá trị cũ
        previousMetas.push({
          selector,
          element: existingMeta,
          oldContent: existingMeta.getAttribute('content'),
        });
        existingMeta.setAttribute('content', content);
      } else {
        // Nếu chưa có -> tạo mới
        const newMeta = document.createElement('meta');
        if (name) newMeta.setAttribute('name', name);
        if (property) newMeta.setAttribute('property', property);
        newMeta.setAttribute('content', content);
        document.head.appendChild(newMeta);

        // Lưu để xóa sau
        previousMetas.push({
          selector,
          element: newMeta,
          created: true,
        });
      }
    });

    return () => {
      // Khôi phục title
      document.title = previousTitle;

      // Khôi phục hoặc xóa meta
      previousMetas.forEach(({ element, oldContent, created }) => {
        if (created) {
          element.remove();
        } else {
          element.setAttribute('content', oldContent);
        }
      });
    };
  }, [title, metas]);
};

export default useMeta;
